import styled from "styled-components";

interface WrapperProps {
    $error?: boolean;
    $minHeight: number;
}

export const StyledCKEditorWrapper = styled.div<WrapperProps>`
    border: 1px solid
        ${({ $error, theme }) =>
            $error ? theme.dangerTypographyColor : theme.secondaryBorderColor};

    border-radius: 6px;
    overflow: hidden;

    transition:
        border-color 0.2s,
        box-shadow 0.2s;

    &:focus-within {
        border-color: ${({ theme }) => theme.colors.primary};
        box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.primary}33;
    }

    --ck-color-base-background: ${({ theme }) => theme.secondaryBackground};
    --ck-color-base-border: ${({ theme }) => theme.secondaryBorderColor};

    --ck-color-toolbar-background: ${({ theme }) =>
        theme.secondaryBackgroundColor};

    --ck-color-text: ${({ theme }) => theme.primaryTypographyColor};

    --ck-color-button-default-hover-background: ${({ theme }) =>
        theme.secondaryBackgroundColor};

    --ck-color-button-on-background: ${({ theme }) => theme.colors.primary};

    /* Toolbar */

    .ck.ck-toolbar {
        border: none !important;
        border-bottom: 1px solid ${({ theme }) => theme.secondaryBorderColor} !important;
        background: ${({ theme }) => theme.secondaryBackgroundColor} !important;
        padding: 6px 8px !important;
    }

    .ck.ck-toolbar .ck-button {
        border-radius: 4px !important;
        min-width: 28px !important;
        min-height: 28px !important;
    }

    .ck.ck-icon,
    .ck.ck-icon svg {
        width: 16px !important;
        height: 16px !important;
    }

    .ck.ck-toolbar__separator {
        background: ${({ theme }) => theme.secondaryBorderColor} !important;
    }

    /* Editable */

    .ck.ck-editor__editable {
        border: none !important;
        box-shadow: none !important;

        min-height: ${({ $minHeight }) => $minHeight}px;

        padding: 10px 12px !important;

        font-size: 16px !important;
        line-height: 1.4 !important;

        color: ${({ theme }) => theme.primaryTypographyColor} !important;
        background: ${({ theme }) => theme.secondaryBackground} !important;

        &.ck-focused {
            outline: none !important;
            box-shadow: none !important;
        }
    }

    .ck.ck-editor__editable p {
        margin: 0 0 6px;
    }

    .ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {
        border: none !important;
    }

    ul,
    ol {
        padding-left: 12px !important;
    }
`;
